import { middlewareTrack } from 'apis/amethyst';
import { CHECKOUT_RECEIVE_ORDER, CHECKOUT_RECEIVE_ORDER_INFORMATION } from 'store/ducks/checkout/types';

const ORDER_CONFIRMATION_PAGEVIEW = 'ORDER_CONFIRMATION_PAGEVIEW';

const amethystTrackOrderShippingDetails = (_appstate, { orderId, deliveryDateRangeDisplayMessage = '', earliestArrivalDate, latestArrivalDate }) => {
  // when no deliveryDateRangeDisplayMessage, user is shown shipping delay message
  middlewareTrack({
    checkoutOrderShippingDetails: {
      amazonPhysicalOrderId: orderId,
      earliestArrivalDate,
      latestArrivalDate,
      deliveryDateRangeDisplayMessage
    }
  });
};

export default {
  clientCalled: CHECKOUT_RECEIVE_ORDER_INFORMATION,
  pageEvent: ORDER_CONFIRMATION_PAGEVIEW,
  hasRedirects: true,
  events: {
    [CHECKOUT_RECEIVE_ORDER]: [amethystTrackOrderShippingDetails]
  }
};
